import { Link } from "react-router-dom";
import { Wrench, Phone, MapPin, ArrowRight } from "lucide-react";

const JOBS = ["TV mounting & setup", "Camera / CCTV systems", "Audio & home theater", "Wi-Fi & network wiring"];

export function InstallBanner() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-16" data-testid="install-banner">
      <div className="relative overflow-hidden rounded-2xl border border-[#FFD600]/30 bg-[#0E1426] p-8 sm:p-10 grid gap-8 lg:grid-cols-12 items-center">
        <div className="lg:col-span-7">
          <span className="dg-chip"><MapPin className="w-3 h-3" /> In person · Los Angeles area</span>
          <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold font-display tracking-tight">Need it installed, not just fixed?</h2>
          <p className="mt-3 text-slate-300">David also comes to you. He has the hands-on experience mounting TVs, wiring surround sound and putting up camera systems across LA — quoted for your home or shop, no online booking needed.</p>
          <ul className="mt-5 grid sm:grid-cols-2 gap-2 text-sm text-slate-200">
            {JOBS.map((j) => <li key={j} className="flex items-center gap-2"><Wrench className="w-4 h-4 text-[#FFD600] shrink-0" /> {j}</li>)}
          </ul>
        </div>
        <div className="lg:col-span-5 flex flex-col gap-3 lg:items-end">
          <Link to="/ask?type=install" className="dg-btn-primary rounded-full px-6 py-3 text-sm flex items-center gap-2" data-testid="install-quote-btn">
            Request an installation quote <ArrowRight className="w-4 h-4" />
          </Link>
          <a href="tel:+13104220669" className="dg-btn-ghost rounded-full px-6 py-3 text-sm flex items-center gap-2" data-testid="install-call-btn">
            <Phone className="w-4 h-4" /> Or call 310-422-0669
          </a>
          <p className="text-xs text-slate-500 lg:text-right">Remote phone & video sessions are still booked online in minutes.</p>
          <p className="text-xs text-slate-500 lg:text-right" data-testid="onsite-policy-note">Can't be fixed over the phone? David can send a technician to finish the job on-site for a separate service charge — quoted before anyone is dispatched.</p>
        </div>
      </div>
    </section>
  );
}
